export default "__VITE_ASSET__AkyQhmE0__"